"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var layer_context_1 = require("./layer-context");
var ESC_CODE = 27;
/**
 *  A Layer is a component that will be rendered outside of the normal application DOM
 * flow. It's mainly used to provide a good a11y experience for overlays and dialogs.
 * This implementation uses React Portal so local state can be shared between a component
 * and the layer it renders.
 */
var Layer = function (_a) {
    var id = _a.id, onDismiss = _a.onDismiss, children = _a.children;
    // Need to use useRef instead of createRef because it needs to be mutable, since elements inside
    // of portals aren't rendered right away.
    var ref = React.useRef(null);
    var _b = __read(React.useState(false), 2), isMounted = _b[0], setIsMounted = _b[1];
    var _c = (0, layer_context_1.useLayerContext)(), layers = _c.layers, dispatchLayerAction = _c.dispatchLayerAction, appBaseRef = _c.appBaseRef, layerRootRef = _c.layerRootRef;
    var index = layers.findIndex(function (layerId) { return layerId === id; });
    var isActive = layers.length && index === layers.length - 1;
    var onKeyUp = React.useCallback(function (event) {
        if (!isActive) {
            return;
        }
        if (event.keyCode === ESC_CODE) {
            event.preventDefault();
            if (onDismiss && typeof onDismiss === 'function') {
                onDismiss();
            }
        }
    }, [onDismiss, isActive]);
    var onClick = React.useCallback(function (event) {
        if (!isActive) {
            return;
        }
        if (event.target === ref.current && onDismiss && typeof onDismiss === 'function') {
            event.preventDefault();
            onDismiss();
        }
    }, [onDismiss, isActive]);
    React.useEffect(function () {
        setIsMounted(true);
        dispatchLayerAction({ id: id, type: 'push' });
        // Save the scroll position if this layer is the first to be mounted
        var pageOffset;
        if (layers.length === 0) {
            pageOffset = {
                x: window.pageXOffset,
                y: window.pageYOffset,
            };
            if (appBaseRef.current) {
                appBaseRef.current.style.transform = "translate(-".concat(window.pageXOffset, "px, -").concat(window.pageYOffset, "px)");
            }
            document.body.classList.add('has-dialog');
            history.scrollRestoration = 'manual';
        }
        return function () {
            dispatchLayerAction({ id: id, type: 'pop' });
            // Clean up the hijacked scroll in the reverse order
            if (pageOffset) {
                document.body.classList.remove('has-dialog');
                window.scrollTo(pageOffset.x, pageOffset.y);
                if (appBaseRef.current) {
                    appBaseRef.current.style.transform = '';
                }
                history.scrollRestoration = 'auto';
            }
        };
    }, []);
    // Never mount the component on the server since it doesn't work with portals.
    if (!isMounted || !layerRootRef.current) {
        return null;
    }
    var layerOverlayClass = "uitk-dialog-layer uitk-dialog-layer-responsive ".concat(isActive ? 'layer-overlay-active' : '');
    var layerKey = "app-layer-stacked-".concat(index);
    var layerId = "app-layer-".concat(id);
    var layer = (React.createElement("div", { id: layerId, className: layerOverlayClass, key: layerKey, "aria-hidden": !isActive, onClick: onClick, onKeyUp: onKeyUp, tabIndex: -1, ref: ref }, children));
    return ReactDOM.createPortal(layer, layerRootRef.current, "layer-".concat(id));
};
exports.Layer = Layer;
//# sourceMappingURL=layer.js.map